module.exports = __webpack_public_path__ + "img/1b.423a00b2.jpg";